<template lang="pug">
.vip-button-container.flex-mid(:class='classes')
  .button-body(@click='open(info)')
    lottie.lottie(:url='json', ref='anime')
    .three
      span.font14 ¥
      span {{info.current}}立即开通
    .toast.part.flex-mid(v-if="info.couponEndTime&&d<1")
      img(src="https://m.hellobike.com/resource/helloyun/08345/74ESsSzstH.png")
      span 已优惠{{(info.original-info.current).toFixed(2) ||"-"}}元
      span ,{{h}}:{{m}}:{{s}}后失效
    .toast-short.part.flex-mid(v-if="(!info.couponEndTime)||d>=1")
      img(src="https://m.hellobike.com/resource/helloyun/08345/74ESsSzstH.png")
      span 已优惠{{(info.original-info.current).toFixed(2) ||"-"}}元
  .hint 购买无忧，不自动续费
  //- .renewal-rules
  //-   span.normal 购买视为同意
  //-   span.canClick(@click="goMember") 《哈啰会员服务协议》
  //-   span.normal 与
  //-   span.canClick(@click="goRenewal")  《自动续费协议》
</template>

<script>
import { commonGoLink } from '@/utils';
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { getSource } from '../../../../utils';

export default {
  components: {
    Lottie,
  },
  props: {
    info: {
      type: Object,
      default: null,
    },
    time: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      json: 'https://m.hellobike.com/resource/helloyun/07177/miBR5C3_ZS.json',
      classes: {
        show: true,
        fixed: true,
      },
      loadingPay: false,
      env,
      d: undefined,
      h: '',
      m: '',
      s: '',
      timer: null,
      timeout: null,
    };
  },
  watch: {
    time(val) {
      if (val) {
        this.openTime();
      }
    },
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_button',
      contentId: 'platform_opencard_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  mounted() {
    if (this.$refs.anime) {
      this.$nextTick(() => {
        this.$refs.anime.lottie.setSpeed(1.3);
      });
    }
    this.openTime();
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  methods: {
    goRenewal() {
      commonGoLink('https://m.hellobike.com/mf/spa/u_hywaxn/latest/MA2209193493443248207695231.html?activityCode=MA2209193493443248207695231', { isRuleLink: true });
    },
    goMember() {
      commonGoLink('https://m.hellobike.com/mf/spa/u_yewmjx/latest/MA2209283520078470713971794.html?activityCode=MA2209283520078470713971794', { isRuleLink: true });
    },
    openTime() {
      const now = new Date().getTime();
      this.timeout = this.time - now;
      this.timer = setInterval(() => {
        if (this.timeout === 0) {
          clearInterval(this.timer);
          return;
        }
        this.showTime(this.timeout);
        this.timeout -= 1000;
      }, 1000);
    },

    showTime(timeout) {
      // 后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
      // eslint-disable-next-line no-console
      if (timeout && timeout > 0) {
        const t = timeout;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        this.d = Math.floor(t / 1000 / 60 / 60 / 24); // 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor((t / 1000 / 60 / 60) % 24);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor((t / 1000 / 60) % 60); // 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor((t / 1000) % 60); // 秒 var s=Math.floor(t/1000%60)
        // if (parseInt(d, 10) < 10) {
        //   this.d = `0${d}`;
        // } else {
        //   this.d = `${d}`;
        // }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      }
    },
    locate() {
      this.classes.fixed = true;
      this.classes.show = true;
    },
    open(val) {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_opencard_button',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_nochoosebutton',
        categoryId: 'platform',
        businessInfo: {
          typeandprice: `2&${this.info.current}`,
        },
      });
      if (val.showPopUpWindowType !== 1) {
        this.$emit('open');
      } else {
        this.$emit('openDialog');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.short-img {
  background-image: url(https://m.hellobike.com/resource/helloyun/08345/7QS2QQgNqA.png);
  font-size: 0.2rem;
}

.vip-button-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 1.62rem;
  flex-direction: column;
  background: white;

  &.show {
    opacity: 1;
  }

  .button-body {
    width: 3.35rem;
    height: 0.52rem;
    background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
    box-shadow: 0 0.01rem 0.08rem 0 rgba(250, 87, 13, 0.4);
    border-radius: 0.08rem;
    position: relative;

    .lottie {
      position: absolute;
      left: 0;
      top: 0;
      width: 3.55rem;
      height: 0.8rem;
      z-index: 1;
    }

    .part {
      position: absolute;
      z-index: 2;
    }

    .toast {
      right: 0.1rem;
      top: -0.2rem;
      height: 0.33rem;
      border-radius: 0.12rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/jXF9OEVxCp.png);
      background-size: 100% 100%;
      font-size: 0.12rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 400;
      color: #793d21;
      line-height: 0.12rem;
      padding: 0.06rem 0.06rem 0.09rem 0.06rem;
      display: flex;
      justify-content: center;

      img {
        width: 0.17rem;
        height: 0.2rem;
      }
    }

    .toast-short {
      right: 0.8rem;
      top: -0.2rem;
      // height: 0.33rem;
      border-radius: 0.12rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/7QS2QQgNqA.png);
      background-size: 100% 100%;
      font-size: 0.12rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 400;
      color: #793d21;
      line-height: 0.12rem;
      padding: 0.06rem 0.08rem 0.09rem 0.08rem;
      display: flex;
      justify-content: center;

      img {
        width: 0.17rem;
        height: 0.2rem;
      }
    }

    .three {
      text-align: center;
      font-size: 0.18rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #fff;
      line-height: 0.52rem;

      .font14 {
        font-size: 0.14rem;
      }
    }
  }

  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    box-shadow: 0 -0.02rem 0.08rem 0 rgba(36, 39, 41, 0.08);
    border-radius: 0.12rem 0.12rem 0 0;
  }

  .hint {
    font-size: 0.12rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    color: #242729;
    margin-top: 0.12rem;
  }

  .renewal-rules {
    margin-top: 0.12rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    color: #879099;
    text-align: center;

    .canClick {
      color: #1993ff;
    }
  }
}
</style>
